export default __webpack_public_path__ + "static/media/oregon.5b33ca3d.svg";